/*!

=========================================================
* Black Dashboard React v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  Button,
  CardTitle,
  Table,
  Row,
  Col,
  Input,
  Form,
  ButtonGroup,
  Label,
  Collapse,
} from "reactstrap";
import withReactContent from "sweetalert2-react-content";
import { option, Toast } from "../../utils/sweetalert";
import { deletePlacesAdmininList, loadNextPlacesAdmins, loadPrevPlacesAdmins, replacePlacesAdmininList, setPlacesAdmin, toggleAllIncompletePlacesAdmininList, toggleIncompletePlacesAdmininList } from "../../redux/actions";
import { getAdminPlacesList, getAdminPlacesListPage, getNAdminPlacesList } from "../../redux/reducers";
import CardAdminDashboard from "../components/CardAdminDashboard";
import InfoPlacePreview from "../components/InfoPlacePreview";
import FormAdminPlacesSection from "./FormAdminPlacesSection";
import queryString from 'query-string'
import api from "../../utils/axiosApi";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Highlighted from "../../utils/Highlighted";

function Activities({
  adminPlaces =[],
  adminPlacesNumber =0,
  page =0,
  setPlacesAdmin=async ()=>{} ,
  loadPrevPlacesAdmins=async ()=>{} ,
  loadNextPlacesAdmins=async ()=>{} ,
  toggleIncompletePlacesAdmininList=async ()=>{} ,
  toggleAllIncompletePlacesAdmininList=async ()=>{} ,
  replacePlacesAdmininList=async ()=>{} ,
  deletePlacesAdmininList=async ()=>{} ,
}) {
  const [country, setCountry] = useState('')
  const [item, setItem] = useState(-1)
  const [edit, setedit] = useState(undefined)
  const [disableChgPg, setdisableChgPg] = useState(false)
  const history = useHistory()
  const values = queryString.parse(history.location.search)
  const [countryActual, setCountryActual] = useState(values?.query || '')
  const [typeData, setTypeData] = useState(values?.type || '')
  //handler search activitie
  
  const [activitieId, setActivitieId] = useState(values?.cityId || '')
  const [state, setState] = useState({
    show:false,
    loading:false,
  })
  
  const [citySearch, setCitySearch] = useState({
      fullName:'',
      _id:''
  })
  const [show, setShow] = useState(false)
  const [cities, setCities] = useState([])
  useEffect(() => {
    const requestActividades = async () => {
      
        try {
          debugger
          await setPlacesAdmin({
            city:activitieId,
            incomplete:typeData || 'true',
            query: values?.query || '',
            page: parseInt(values?.page || 1)-1
          })
        } catch (error) {
          //console.log(error)
        } 
    }
    requestActividades()
    return 
  }, [])
  const handleDelete = async (c) => {
    const MySwal = withReactContent(option)
      const resp = await MySwal.fire({
      title: <p style={{fontSize: '2.2rem', zIndex: 30000}}>Desea Eliminar Completamente esta actividad?</p>,
      text: 'Presione eliminar para continuar o presione afuera para salir',
      confirmButtonText: 'Eliminar',
      icon:'question',
      focusConfirm: false,
    })
    if(resp.isConfirmed) {
      try {
        await deletePlacesAdmininList(c._id)
      } catch (error) {
        //console.log(error)
      }
    }
  }
  const handleChange = (e) => {
    setCountry( e.target.value)
  }
  const handleConfirmeAllPage = async (e) => {
    try {
      setdisableChgPg(true)
      
      await toggleAllIncompletePlacesAdmininList()
      
      setdisableChgPg(false)
    } catch (error) {
      //console.log(error)
    }
  }
  const handleNewquerySearch =async ({city,query,incomplete})=>{
    try {
      setdisableChgPg(true)
      var cityData = city || activitieId
      var queryData = query || countryActual
      var incompleteData = incomplete || 'true'
      if(city === ''){
        cityData=''
      }
      await setPlacesAdmin({
        incomplete:incompleteData,
        city:cityData,
        query:queryData
      })
      history.push({
        pathname: history.location.pathname,
        search:`?query=${queryData}${incomplete ? `&&type=${incomplete}`:''}${cityData ? `&&cityId=${cityData}`:''}`
      })
      setdisableChgPg(false)
      
    } catch (error) {
      //console.log(error)
    }

  }
  const handleSearch = async (e) => {
    e.preventDefault()
    if(country === countryActual) return
    try {
      setCountryActual(country)
      
      await handleNewquerySearch({query:country,incomplete:typeData})
    } catch (error) {
      //console.log(error)
    }
  }
  const handlechangeType = async (e) => {
    try {
      setTypeData(e.target.value)
      await handleNewquerySearch({query:country,incomplete:e.target.value})
    } catch (error) {
      //console.log(error)
    }
  }
  
  const nextPage = async () => {
    if(page+1 === adminPlacesNumber) {return}
    setdisableChgPg(true)
    const newPage = await loadNextPlacesAdmins()
    history.push({
      pathname: history.location.pathname,
      search:`?page=${newPage+1}${countryActual ? `&&query=${countryActual}`:''}${typeData ? `&&type=${typeData}`:''}${activitieId ? `&&cityId=${activitieId}`:''}`
    })
    setdisableChgPg(false)
    
  }
  const PrevPage = async () => {
    
    if(page === 0) {return}
    setdisableChgPg(true)
    const newPage = await loadPrevPlacesAdmins()
    history.push({
      pathname: history.location.pathname,
      search:`?page=${newPage+1}${countryActual ? `&&query=${countryActual}`:''}${typeData ? `&&type=${typeData}`:''}${activitieId ? `&&cityId=${activitieId}`:''}`
    })
    setdisableChgPg(false)

  }
  const handlehide = async (c) => {
    try {
      await toggleIncompletePlacesAdmininList(c._id)
    } catch (error) {
      //console.log(error)
    }
  }
  
  const handleChangeCityInput= async (e) => {
    setCitySearch({
        fullName:e.target.value,
        _id:''
    })
    if(e.target.value !== '') {
        if(cities.length === 0){
            setState({
                loading:true
            })
        }
        try {
            setShow(true)
            const resp = await api.get(`/ciudades/getcities?disabledHide=true&&city=${e.target.value}`)
            if(resp.data.query === e.target.value) {
                setCities(resp.data.data)
                setState({
                    loading:false
                })
            }
        } catch (error) {
          setCities([])
            setState({
                loading:false
            })
            //console.log(error)
        }
    } else {setCities([]); 
        setShow(false)
        setState({
        loading:false
    })}
}
  return (
    <>
      {!edit && <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <Row xs='2'> 
                <Col className="pr-md-1" xs='12' md="8"><CardTitle tag="h4">Actividades</CardTitle></Col>
                <Col className="pr-md-1" xs='12' md="4">
                <ButtonGroup>
                  <Button draggable={disableChgPg} onClick={PrevPage}>Anterior</Button>
                  <Button disabled>{page+1} de {adminPlacesNumber}</Button>
                  <Button draggable={disableChgPg} onClick={nextPage}>Siguiente</Button>
                </ButtonGroup>
                </Col>
                <Col className="pr-md-1" xs="6">
                  <Form onSubmit={handleSearch}>
                    <Row>
                    <Col className="pr-md-1" xs="8">
                    <Input value={country} onChange={handleChange} type='text'>
                    {/* <option key={`countries`} value=''>{`Todos`}</option> 
                    {countryJSON.countries.map((c,i) => {
                        return <option key={`countries-${i}`} value={c.name}>{`${c.name}`}</option>
                    })} */}
                    </Input></Col>
                    
                    <Col className="p-0" xs="4">
                    <ButtonGroup size='sm'>
                      <Button type='submit' >Buscar</Button>
                    </ButtonGroup>
                    </Col>
                    
                    </Row>
                  </Form>
                </Col>
                <Col className="pr-md-1" xs="6">
                    <Label>valor faltante</Label>
                    <Input value={typeData} onChange={handlechangeType} type='select'>
                     <option key={`selector`} value=''>{`cualquiera`}</option> 
                    {[
                      'workingH',
                      'urlImg',
                      'title',
                      'stars',
                      'place',
                    ].map((c,i) => {
                        return <option key={`countries-${i}`} value={c}>{`${c}`}</option>
                    })} 
                    </Input>
                </Col> 
                  <Col  className=' mb-2 p-0'>
                    <form onSubmit={async(e)=>{
                      e.preventDefault();
                      setActivitieId('');
                      await handleNewquerySearch({city:''})
                      setCitySearch({
                        fullName:''
                      })} } style={{zIndex:6}} className='SearchInfoCont SearchCitiesCont d-flex' >
                      <input style={{height:'35px'}} onChange={handleChangeCityInput} className='searchinput' value={citySearch.fullName} placeholder={'buscar actividad'} type='search'></input>
                      <button className='searchbutton searchbuttoncities  rounded-circle mt-0' type='submit'><FontAwesomeIcon icon='times'></FontAwesomeIcon></button>
                          
                      <Collapse  style={{position: 'absolute', top:'45px', left:0, right:0}} isOpen={(show)}>
                        <ul style={{zIndex: 300, position:'relative', top:0}} className='optionsSearch'> 
                          {(!state.loading) && cities.map(e => {
                          
                            var cityString = e.city
                              var country = e.country
                              const place = `${cityString}, ${country}`
                              const cityText = Highlighted({text:cityString, highlight:citySearch.fullName})
                              const countrytext = Highlighted({text:country, highlight:citySearch.fullName})
                          return (<li className='optionAutoComplete' onClick={async () => {
                              setCitySearch({
                                  fullName:place,
                                  _id:e._id
                              })
                              setActivitieId(e._id)
                              setState({
                                  loading:false
                              })
                              setShow(false)
                              await handleNewquerySearch({city:e._id})

                            }}>{cityText},<span> {` `}{countrytext}</span></li>
                          )}
                          )}
                          {(cities.length===0 && !state.loading ) && <li className='optionAutoComplete'>ciudad no encontrada<span></span></li> }
                          {(!state.loading) ? <></> : 
                              <div className='d-flex justify-content-center' style={{color: '#E5E9F2' ,fontSize: '50px', width:'100%', padding: '5px 0'}}>
                              <FontAwesomeIcon spin icon='circle-notch'/>
                          </div>
                          }
                        </ul>
                      </Collapse>
                    </form>
                  </Col>
                  <Col className="pr-md-1" xs="2">
                      <Button draggable={disableChgPg} type="button" onClick={handleConfirmeAllPage} color="danger">confirmar toda la pagina</Button>
                  </Col> 
                </Row>
              </CardHeader>
              {/* <CardBody>
                <Table className="tablesorter" responsive>
                  <thead className="text-primary">
                    <tr>
                      <th>Nombre</th>
                      <th className="text-center">Lugar</th>
                      <th className="text-center">Estrellas</th>
                      <th className="text-center">Coordenadas</th>
                      <th className="text-center">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {adminPlaces.map((c, index) => (
                      <tr key={`actividad-${index}`}>
                        <td><FontAwesomeIcon icon={c.hide ? 'eye-slash': 'eye'}/>{c.name}</td>
                        <td className="text-center">{c.place}</td>
                        <td className="text-center">{c.stars}</td>
                        <td className="text-center">{`${c.lat}, ${c.lon}`}</td>
                        <td className="text-center">
                        <Button onClick={() => {handlehide(c)}}  size='sm' type='button' color='secundary'>{c.hide ? 'Mostrar': 'Ocultar'}</Button>
                        <Button onClick={() => {handleDelete(c)}}  size='sm' type='button' color='danger'>Eliminar</Button>
                        <Button onClick={() => {
                          history.push({
                            pathname: `/admin/edit-Activity/${c._id}`,
                            state: c
                          })
                        }}  size='sm' type='button' color='primary'>Editar</Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </CardBody> */}
              <CardBody>
                <Row className="justify-content-center">
                {(adminPlaces.length===0 && !disableChgPg) && <CardTitle tag="h4">Sin lugares</CardTitle>}
                {(adminPlaces.length===0 && disableChgPg) && <CardTitle tag="h4">Cargando</CardTitle>}
                {adminPlaces.map((e,i)=> {
                    return (<Col style={{marginBottom: '30px'}} className={`flex-grow-0 `} key={`cards_${i}`}>
                    <CardAdminDashboard
                    onElementInScreen={(place,inView)=> {}}
                    modeMap={false}
                    onHidePlace={() => {handlehide(e)}}
                    onDeletePlace={() => {handleDelete(e)}}
                    onOpenPlace={() => {
                      setItem(i)
                          /*history.push({
                            pathname: `/admin/edit-Activity/${e._id}`,
                            state: e
                          })*/
                        }}
                    key={`placeAdmins_${i}`}
                    place={e}
                    thumbs
                    stateAct={e.incomplete}
                    /></Col>)
                    })}
                </Row>
              </CardBody>
            </Card>
          </Col>
          
        </Row>
      </div>}
      {edit &&<FormAdminPlacesSection
      onEditSuccess={(it)=>{replacePlacesAdmininList(it)}}
      onBack={()=>{setedit(undefined)}}
      calendarData={edit}
      ></FormAdminPlacesSection>}
      {item>=0 && <InfoPlacePreview 
                onPlacesSelect={()=>{}}
                place={adminPlaces[item]}
                onToggleAct={()=>{
                  setedit(adminPlaces[item])
                  setItem(-1)
                }}
                onNextAct={async ()=>{
                  if(item>=19) {
                    await nextPage()
                    setItem(0)
                    return
                  }
                  setItem(item + 1)
                }}
                onPrevAct={()=>{
                  if(item<=-1) return
                  setItem(item - 1)
                  }}
                shopCarListId={[]}
                onClose={()=>{setItem(-1)}}
                className='totalPopUpCont' style={{zIndex:'800'}}></InfoPlacePreview>
              }
    </>
  );
}

const mapStateToProps = state => {
  return ({
      adminPlaces: getAdminPlacesList(state),
      adminPlacesNumber: getNAdminPlacesList(state),
      page: getAdminPlacesListPage(state)
})}
const mapDispatchToProps = dispatch => (
  {
      setPlacesAdmin: value =>dispatch(setPlacesAdmin(value)),
      loadPrevPlacesAdmins: value =>dispatch(loadPrevPlacesAdmins(value)),
      loadNextPlacesAdmins: value =>dispatch(loadNextPlacesAdmins(value)),
      toggleIncompletePlacesAdmininList: value =>dispatch(toggleIncompletePlacesAdmininList(value)),
      toggleAllIncompletePlacesAdmininList: value =>dispatch(toggleAllIncompletePlacesAdmininList(value)),
      replacePlacesAdmininList: value =>dispatch(replacePlacesAdmininList(value)),
      deletePlacesAdmininList: value =>dispatch(deletePlacesAdmininList(value)),
  })

export default connect(mapStateToProps,mapDispatchToProps)(Activities);
